import { buildTestLevel, createTestPost } from './testScene.js';

/**
 * Dev-scene registry. Any task can drop a module into `src/engine/dev/scenes/`
 * and it becomes routable at `/play/<name>` with ZERO edits to shared files —
 * this is what lets parallel wave agents ship reviewable demos without
 * conflicting on App.jsx.
 *
 * A scene module may export:
 *   buildLevel(ctx) -> Level      (required; same contract as real levels)
 *   createPost(engine) -> post    (optional; assigned to engine.post)
 *   engineOpts                    (optional; camera framing etc.)
 *   label                         (optional; HUD caption)
 */
const modules = import.meta.glob('./scenes/*.js');

export function listDevScenes() {
  return Object.keys(modules).map((k) => k.slice('./scenes/'.length, -'.js'.length));
}

export async function resolveDevScene(id) {
  const key = `./scenes/${id}.js`;
  if (modules[key]) {
    const mod = await modules[key]();
    return {
      buildLevel: mod.buildLevel,
      createPost: mod.createPost ?? null,
      engineOpts: mod.engineOpts ?? {},
      label: mod.label ?? `dev scene: ${id}`,
    };
  }
  // Fallback: the T0 stack-proof scene.
  return {
    buildLevel: buildTestLevel,
    createPost: createTestPost,
    engineOpts: { distance: 11, pitchDeg: 52, yawDeg: 30 },
    label: 'stack-proof scene',
  };
}
